module.exports = __webpack_public_path__ + "img/mediate_bg.6700805a.png";